module.exports = __webpack_public_path__ + "media/images/img_support04-f67bf8f6655f43e8752f8f66f1a869de.jpg";